import { Route } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ExpertAuthGuard,
  ExpertLayoutComponent,
  ExpertDashboardComponent,
  expertRoutePermissionGuard,
} from '@sandbox-platform/expert-app-lib';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ExpertLayoutComponent,
    canActivate: [ExpertAuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: ExpertDashboardComponent,
        canMatch: [expertRoutePermissionGuard],
      },
      {
        path: 'expert',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.expertRoutes
          ),
      },
      {
        path: 'personnel',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.personnelRoutes
          ),
      },
      {
        path: 'organizations',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.organizationRoutes
          ),
      },
      {
        path: 'industries',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.industryRoutes
          ),
      },

      {
        path: 'attendance-tracking',
        canMatch: [expertRoutePermissionGuard],
        loadComponent: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.AttendanceTrackingComponent
          ),
      },
      {
        path: 'attendance',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.attendanceRoutes
          ),
      },
      {
        path: 'referrals',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.referralRoutes
          ),
      },
      {
        path: 'commission-rules',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.commissionDirectionRoutes
          ),
      },
      {
        path: 'referral-source-channels',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.referralSourceChannelRoutes
          ),
      },
      {
        path: 'commission-invoices',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.commissionInvoiceRoutes
          ),
      },
      {
        path: 'commission-payments',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.commissionPaymentRoutes
          ),
      },
      {
        path: 'commissions',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.commissionRoutes
          ),
      },
      {
        path: 'attendance-settings',
        canMatch: [expertRoutePermissionGuard],
        loadComponent: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.AttendanceSettingsDetailComponent
          ),
      },
      {
        path: 'commission-settings',
        canMatch: [expertRoutePermissionGuard],
        loadComponent: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.CommissionSettingsDetailComponent
          ),
      },
      {
        path: 'api-token-settings',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.apiTokenSettingsRoutes
          ),
      },
      {
        path: 'profile',
        canMatch: [expertRoutePermissionGuard],
        loadComponent: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.UserProfileComponent
          ),
      },
      {
        path: 'custom-attributes',
        canMatch: [expertRoutePermissionGuard],
        loadChildren: () =>
          import('@sandbox-platform/expert-app-lib').then(
            (m) => m.customAttributeRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
